var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "add-activity-note-modal",
      "modal-dialog-size": "lg",
      "modal-dialog-centered": false,
      "modal-dialog-scrollable": false,
      "tab-index": null,
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("boards.actions.addNoteActivity")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("quick-actions", {
              ref: "quickActions",
              attrs: { "client-profile-id": _vm.localClientProfileId },
              on: {
                change: _vm.updateQuickActions,
                "validation-change": _vm.handleValidationChange,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "button",
                  loading: _vm.buttonIsLoading,
                  "class-name": "btn btn-primary btn-sm",
                  disabled: _vm.invalidReminder && _vm.invalidNote,
                },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.add")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }